import { getSEOEndpoint as getSEOEndpointUtil } from '@nykaa/utils/urls';

export enum ROUTES {
  PRODUCT,
  AUTH,
  RECO_WIDGETS,
  CHECK_DELIVERY,
  SEARCH_SUGGESTIONS,
  TRENDING_SEARCHES,
  GATEWAY,
  OFFERS,
  REVIEW_PHOTOS,
  LIKE_REVIEW,
  NAVIGATION,
  LOGOUT,
  QNA,
  NEWS_LETTER_SUBSCRIPTION,
  GET_VARIANTS,
  GRAPH_API,
  FB_API,
  GOOGLE_API,
  LOGIN,
  PRODUCT_LIST,
  DEVICE_TRACKING_SERVICE,
  CATEGORY_PRICE_LIST,
  FOOTER_CATEGORIES,
  ABOUT_US,
  SEARCH_LISTING,
  OFFER_PRODUCT_LIST,
  DESKTOP_NAVIGATION,
  LOGOUT_ALL,
  USER_CHAT_HASH,
  BREADCRUMBS,
  GAME_GET_OFFER,
  GAME_CLAIM_OFFER,
}

export const urls: { [key: string]: string } = {
  [ROUTES.PRODUCT]: '/app-api/index.php/products/details',
  [ROUTES.AUTH]: '/ReactConfig.php',
  [ROUTES.RECO_WIDGETS]: '/gateway-api/rest/appapi/V2/getProductWidgets',
  [ROUTES.CHECK_DELIVERY]: '/custom/index/enterpincode',
  [ROUTES.SEARCH_SUGGESTIONS]: '/gludo/searchSuggestions',
  [ROUTES.TRENDING_SEARCHES]: '/search/trending',
  [ROUTES.GATEWAY]: '/gateway-api',
  [ROUTES.LIKE_REVIEW]: '/advancereview/index/like',
  [ROUTES.OFFERS]: '/gateway-api/offer/api/v1/product/{productId}/offer',
  [ROUTES.NAVIGATION]: '/getNavigation.php',
  [ROUTES.LOGOUT]: '/customer/account/logout/',
  [ROUTES.QNA]: '/custom/index/getqna',
  [ROUTES.NEWS_LETTER_SUBSCRIPTION]: '/newsletter/subscriber/customnew',
  [ROUTES.GET_VARIANTS]: '/gludo/listVariants',
  [ROUTES.GRAPH_API]: 'https://graph.facebook.com/me?fields=name,email',
  [ROUTES.FB_API]: '/app-api/index.php/user/sec_login_fb',
  [ROUTES.GOOGLE_API]: '/app-api/index.php/user/sec_login_google',
  [ROUTES.LOGIN]: '/customer/account/ajaxLogin/',
  [ROUTES.PRODUCT_LIST]: '/app-api/index.php/products/list',
  [ROUTES.DEVICE_TRACKING_SERVICE]: '/trk/device',
  [ROUTES.CATEGORY_PRICE_LIST]: '/app-api/index.php/categories/price_listing',
  [ROUTES.FOOTER_CATEGORIES]: '/gateway-api/api/v1/seo/footer_categories',
  [ROUTES.ABOUT_US]: '/gateway-api/api/v1/categories/dataForAboutSection',
  [ROUTES.SEARCH_LISTING]: '/api/search.list',
  [ROUTES.OFFER_PRODUCT_LIST]: '/app-api/index.php/products/list/offer',
  [ROUTES.DESKTOP_NAVIGATION]: '/app-api/index.php/react/navigation',
  [ROUTES.LOGOUT_ALL]: '/app-api/index.php/customer/logout_from_all_session',
  [ROUTES.USER_CHAT_HASH]: '/gateway-api/omsApis/getChatParams',
  [ROUTES.BREADCRUMBS]: '/api/v1/products/getBreadCrumb',
  [ROUTES.GAME_GET_OFFER]: '/gateway-api/gamification/getOffer',
  [ROUTES.GAME_CLAIM_OFFER]: '/gateway-api/gamification/claimcoupon',
};

export const getAPIHost = () =>
  __SERVER__ ? process.env.API_INTERNAL_HOST : process.env.API_HOST;

export const getUrl = (uri: ROUTES): string =>
  `${getAPIHost() || ''}${urls[uri]}`;

export const getGatewayUrl = () =>
  __SERVER__
    ? process.env.GATEWAY_API_INTERNAL
    : `${process.env.API_HOST || ''}/gateway-api`;

export const getUrlPrefixed = (
  requestPath: string,
  clientPrefix: string = '',
  serverPrefix: string = ''
) => {
  if (__SERVER__) {
    return `${serverPrefix}${requestPath}`;
  }
  return `${clientPrefix}${requestPath}`;
};

export const getDealsEndpoint = () =>
  __SERVER__ ? process.env.DEALS_INTERNAL_ENDPOINT : process.env.DEALS_ENDPOINT;

export const getDealsUrl = () => `${getDealsEndpoint()}/inventory/data/json/`;

export const getSeoUrl = (uri: ROUTES): string => {
  const endpoint = getSEOEndpointUtil() || '';
  return `${endpoint}${urls[uri]}`;
};

export const getEventsUrl = () => process.env.SP_EVENTS_URL || '';
